import activeCreditTypeReducer from '../activeCreditTypeReducers'
import activeCurrencyReducer from '../activeCurrencyReducers'
import activeEnhancementReducer from '../activeEnhancementReducers'
import activePromoReducer from '../activePromoReducers'
import activeRestaurantsReducer from '../activeRestaurantsReducers'
import activeRoomReducer from '../activeRoomReducers'
import activeRoomClassReducer from '../activeRoomClassReducers'
import activeStepReducer from '../activeStepReducers'
import createCartReducer from '../createCartReducers'
import createReservationReducer from '../createReservationReducers'
import createRestaurantReservationReducer from '../createRestaurantReservationReducers'
import editStayGuestReducer from '../editStayGuestReducer'
import fetchAvailabilityReducers from '../fetchAvailabilityReducers'
import fetchConfigurationReducers from '../fetchConfigurationReducers'
import fetchEnhancementsReducers from '../fetchEnhancementsReducers'
import fetchExchangeRatesReducers from '../fetchExchangeRatesReducers'
import fetchHotelContentFeedsReducers from '../fetchHotelContentFeeds'
import fetchHotelDescriptiveInfoReducers from '../fetchHotelDescriptiveInfoReducers'
import fetchLoyaltyRatesReducers from '../fetchLoyaltyRatesReducers'
import fetchPropertyAvailabilityReducers from '../fetchPropertyAvailabilityReducers'
import fetchTransactionTokenData from '../fetchTransactionTokenReducers'
import fetchUserReducers from '../fetchUserReducers'
import getPromoReducers from '../requestPromoReducers'
import multiRoomReducer from '../multiRoomReducers'
import preCheckTimeReducer from '../preCheckTimeReducers'
import recordDsp2TransactionReducers from '../recordDsp2TransactionReducers'
import restaurantAvailabilityReducers from '../restaurantAvailabilityReducers'
import roomRateDetailsReducers from '../fetchRoomRateDetailsReducers'
import setProfileReducers from '../setProfileReducers'
import setRestaurantsReducers from '../setRestaurantsReducers'
import setEditStayPropertyReducer from '../setEditStayPropertyReducer'
import validateSpecialCodeReducers from '../../reducers/validateSpecialCodeReducers'
import setUserSessionReducers from '../setUserSessionReducers'
import { combineReducers } from 'redux'

import { reducer as form } from 'redux-form'

const rootReducer = combineReducers({
	activeCartData: createCartReducer,
	activeCreditData: activeCreditTypeReducer,
	activeCurrencyData: activeCurrencyReducer,
	activeEnhancementData: activeEnhancementReducer,
	activePromoData: activePromoReducer,
	activeRestaurantsData: activeRestaurantsReducer,
	activeRoomData: activeRoomReducer,
	activeRoomClassData: activeRoomClassReducer,
	activeStepData: activeStepReducer,
	availabilityData: fetchAvailabilityReducers,
	configData: fetchConfigurationReducers,
	dsp2TransactionData: recordDsp2TransactionReducers,
	editStayGuestData: editStayGuestReducer,
	editStayPropertyData: setEditStayPropertyReducer,
	enhancementData: fetchEnhancementsReducers,
	exchangeRatesData: fetchExchangeRatesReducers,
	hotelContentFeeds: fetchHotelContentFeedsReducers,
	hotelDescriptiveInfo: fetchHotelDescriptiveInfoReducers,
	loyaltyRatesData: fetchLoyaltyRatesReducers,
	multiRoomData: multiRoomReducer,
	preCheckTimeData: preCheckTimeReducer,
	profileData: setProfileReducers,
	profileUserData: fetchUserReducers,
	propertyAvailabilityData: fetchPropertyAvailabilityReducers,
	requestPromoData: getPromoReducers,
	reservationData: createReservationReducer,
	restaurantReservationData: createRestaurantReservationReducer,
	restaurantAvailabilityData: restaurantAvailabilityReducers,
	restaurantData: setRestaurantsReducers,
	roomRateDetailsData: roomRateDetailsReducers,
	specialCodeAvailability: validateSpecialCodeReducers,
	transactionTokenData: fetchTransactionTokenData,
	userSessionData: setUserSessionReducers,
	form
})

export default rootReducer




// WEBPACK FOOTER //
// ./src/reducers/configuration/index.js